import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";
import {
  type ForwardedRef,
  forwardRef,
  type HTMLAttributes,
  type PropsWithChildren,
} from "react";

const linkButtonStyles =
  ({ color }: { color: "cyan" | "blue" }) =>
  (theme: ExactTheme) => css`
    color: ${theme.colorsV2[color][500]};
    font-size: ${theme.fontSizesV2.body};
    font-weight: ${theme.fontWeights.normal};
    border: none;
    padding: 0;
    background: transparent;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  `;

export type LinkButtonProps = PropsWithChildren<
  Omit<HTMLAttributes<HTMLButtonElement>, "color">
> & {
  color?: "cyan" | "blue";
};

export const LinkButton = forwardRef(
  (
    { children, color = "cyan", ...restProps }: LinkButtonProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    return (
      <button
        ref={ref}
        {...restProps}
        css={linkButtonStyles({
          color,
        })}
      >
        {children}
      </button>
    );
  },
);
